import { useResponsive } from '@mfw/components';
import classNames from 'classnames';

export type PageLayoutSize =
  | 'lg:w-1/1'
  | 'lg:w-1/2'
  | 'md:w-1/1'
  | 'md:w-1/2'
  | 'sm:w-1/1'
  | 'sm:w-1/2'
  | 'w-1/1'
  | 'w-1/2'
  | 'xl:w-1:1'
  | 'xl:w-1:2';

export interface PageLayoutProps {
  withShadedBackground?: boolean;
  sizes: Array<PageLayoutSize>;
  children?: React.ReactNode;
  className?: string;
  rounded?: boolean;
}
const PageLayout = ({
  children,
  className,
  rounded,
  sizes,
  withShadedBackground,
}: PageLayoutProps) => {
  const isMobile = useResponsive('down', 'sm');
  return (
    <div
      className={classNames(
        'h-full',
        isMobile ? 'w-full' : sizes,
        {
          'bg-background-paper': withShadedBackground,
          'rounded-2xl': rounded,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

export default PageLayout;
